import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatePhase } from '../../../../store/actions/admin/assistant';
import {
	EAssistantPhase,
	IChecklistItem,
	ProgressHeaders,
} from '../../../../store/reducers/admin/assistant';
import { EventsState } from '../../../../store/types';
import Icon, { COLORS, ICONS } from '../../../general-ui/icon';
import ChecklistItem from './checklist-item';
import './progress-checklist.scss';

const ProgressAssistant: React.FC = () => {
	const {
		AssistantReducer: { checklistOptions },
		CreateEventReducer: { workingEvent }
	} = useSelector((state: EventsState) => state);


	const dispatch = useDispatch();

	const [activeHeader, setActiveHeader] = useState<string | null>(null);

	// render checklist items based on which header is clicked
	// if the active header is clicked again, all headers are closed
	function handleClick(header: string) {
		if (activeHeader === header) setActiveHeader(null);
		else setActiveHeader(header);
	}

	// render the progress checklist with appropriate headers for current event
	// render checklist items based on active header
	const renderBody = useMemo(() => {
		return (
			<div className="progress-body">
				{Object.values(ProgressHeaders).map((type: string) => {
					// don't return checklist headers that don't apply to current event (registration, homepage, landing page)
					if (
						// if landing page is turned off for event, filter out all checklist items
						// with type of eventHomepage and landingPage
						(!workingEvent?.homepage && ( type === ProgressHeaders.eventHomepage || type === ProgressHeaders.landingPage)) || 
						// if registration is turned off for event, filter out all achecklist items
						// with type of registration
						( !workingEvent?.registration_on && type === ProgressHeaders.registration )
					)
					{
						return;
					} else {
						return (
							<div key={type}>
								<div
									className="progress-dropdown"
									onClick={() => {
										handleClick(type);
									}}
								>
									<h6>{type}</h6>
								</div>
								<div className="progress-options-list">
									{activeHeader === type ? (
										checklistOptions.map((option: IChecklistItem) => {
											if (option.type === type)
												return (
													<ChecklistItem key={option.title} option={option} />
												);
										})
									) : (
										<></>
									)}
								</div>
							</div>
						);
					}
				})}
			</div>
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [activeHeader, checklistOptions, workingEvent?.registration_on, workingEvent?.homepage]);

	return (
		<div className="progress-assistant-container">
			<div className="progress-header">
				<button
					className="no-style"
					onClick={() => dispatch(updatePhase(EAssistantPhase.MENU))}
				>
					<Icon name={ICONS.ARROW_LEFT} size={16} color={COLORS.WHITE} />
				</button>
				<h4>Progress checklist</h4>
			</div>
			{renderBody}
			<div className="progress-footer"></div>
		</div>
	);
};

export default ProgressAssistant;
